/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var ChatWidgetSenderIdentity;
(function (ChatWidgetSenderIdentity) {
    ChatWidgetSenderIdentity["Undefined"] = "Undefined";
    ChatWidgetSenderIdentity["Anonymous"] = "Anonymous";
    ChatWidgetSenderIdentity["Agent"] = "Agent";
    ChatWidgetSenderIdentity["Business"] = "Business";
})(ChatWidgetSenderIdentity = exports.ChatWidgetSenderIdentity || (exports.ChatWidgetSenderIdentity = {}));
var EmailSenderIdentity;
(function (EmailSenderIdentity) {
    EmailSenderIdentity["Undefined"] = "Undefined";
    EmailSenderIdentity["Business"] = "Business";
    EmailSenderIdentity["AgentAndBusiness"] = "AgentAndBusiness";
    EmailSenderIdentity["Agent"] = "Agent";
})(EmailSenderIdentity = exports.EmailSenderIdentity || (exports.EmailSenderIdentity = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var IntegrationStatus;
(function (IntegrationStatus) {
    IntegrationStatus["Undefined"] = "Undefined";
    IntegrationStatus["Active"] = "Active";
    IntegrationStatus["Invalid"] = "Invalid";
    IntegrationStatus["Disconnected"] = "Disconnected";
})(IntegrationStatus = exports.IntegrationStatus || (exports.IntegrationStatus = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var LcfAppearanceType;
(function (LcfAppearanceType) {
    LcfAppearanceType["UNDEFINED"] = "UNDEFINED";
    LcfAppearanceType["ON_MESSAGE"] = "ON_MESSAGE";
    LcfAppearanceType["ON_OPEN"] = "ON_OPEN";
})(LcfAppearanceType = exports.LcfAppearanceType || (exports.LcfAppearanceType = {}));
var LcfFieldType;
(function (LcfFieldType) {
    LcfFieldType["UNDEFINED"] = "UNDEFINED";
    LcfFieldType["NAME"] = "NAME";
    LcfFieldType["EMAIL"] = "EMAIL";
    LcfFieldType["PHONE"] = "PHONE";
    LcfFieldType["CUSTOM"] = "CUSTOM";
})(LcfFieldType = exports.LcfFieldType || (exports.LcfFieldType = {}));
var Mode;
(function (Mode) {
    Mode["Undefined"] = "Undefined";
    Mode["Manual"] = "Manual";
    Mode["Automatic"] = "Automatic";
})(Mode = exports.Mode || (exports.Mode = {}));
var Occurs;
(function (Occurs) {
    Occurs["Undefined"] = "Undefined";
    Occurs["Monday"] = "Monday";
    Occurs["Tuesday"] = "Tuesday";
    Occurs["Wednesday"] = "Wednesday";
    Occurs["Thursday"] = "Thursday";
    Occurs["Friday"] = "Friday";
    Occurs["Saturday"] = "Saturday";
    Occurs["Sunday"] = "Sunday";
})(Occurs = exports.Occurs || (exports.Occurs = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Type;
(function (Type) {
    Type["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    Type["TYPE_FLOAT"] = "TYPE_FLOAT";
    Type["TYPE_INT64"] = "TYPE_INT64";
    Type["TYPE_UINT64"] = "TYPE_UINT64";
    Type["TYPE_INT32"] = "TYPE_INT32";
    Type["TYPE_FIXED64"] = "TYPE_FIXED64";
    Type["TYPE_FIXED32"] = "TYPE_FIXED32";
    Type["TYPE_BOOL"] = "TYPE_BOOL";
    Type["TYPE_STRING"] = "TYPE_STRING";
    Type["TYPE_GROUP"] = "TYPE_GROUP";
    Type["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    Type["TYPE_BYTES"] = "TYPE_BYTES";
    Type["TYPE_UINT32"] = "TYPE_UINT32";
    Type["TYPE_ENUM"] = "TYPE_ENUM";
    Type["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    Type["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    Type["TYPE_SINT32"] = "TYPE_SINT32";
    Type["TYPE_SINT64"] = "TYPE_SINT64";
})(Type = exports.Type || (exports.Type = {}));
var VatType;
(function (VatType) {
    VatType["UNSPECIFIED"] = "UNSPECIFIED";
    VatType["CPF"] = "CPF";
    VatType["CNPJ"] = "CNPJ";
})(VatType = exports.VatType || (exports.VatType = {}));
var VirtualNumberStatus;
(function (VirtualNumberStatus) {
    VirtualNumberStatus["Unknown"] = "Unknown";
    VirtualNumberStatus["Active"] = "Active";
    VirtualNumberStatus["Pending"] = "Pending";
    VirtualNumberStatus["Suspended"] = "Suspended";
})(VirtualNumberStatus = exports.VirtualNumberStatus || (exports.VirtualNumberStatus = {}));
